var _module_exports = "<div class=\"flex-nav sf-fill-extents flex-col sf-host-top\">\n  <super-powers class=\"flex-auto\"></super-powers>\n</div>\n";;
var path = '/builds/observability/imm/signalview/src/legacy/app/superpowers/superpowershost.tpl.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;